import React from 'react';
import gql from "graphql-tag";

export const GET_QUOTE = gql`
    mutation quote($groupSize: Int!, $pickUpAddress: String!, $dropOffAddress: String!) {
        calculateQuote(
            data: {
                groupSize: $groupSize,
                pickUpAddress: $pickUpAddress,
                dropOffAddress: $dropOffAddress
            }
        )
        {
            success
            code
            message
            quoteAmount
            distanceInMiles
            numberOfBoats
            id
        }
    }
`

export const GET_QUOTES = gql`
    mutation getQuotes {
        getQuotes {
            success
            message
            quotes {
                firstName
                lastName
                email
                phone
                groupSize
                pickUpAddress
                dropOffAddress
                quoteAmount
                createdAt
                distanceInMiles
                rideRequested
            }
        }
    }
`

